import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-shared-profile',
  templateUrl: './shared-profile.component.html',
  styleUrls: ['./shared-profile.component.css']
})
export class SharedProfileComponent implements OnInit {
  
  
  constructor() { }

  ngOnInit(): void {

  }




}
